import {post} from '@/utils/request';
import {erpserver} from '@/utils/baseUrl';


// 获取分厂
export async function fcList(params) {
    return post(erpserver+'/taskrpt/fcList', params, true);
}
// 获取任务统计列表
export async function fcxjList(params) {
    return post(erpserver+'/taskrpt/fcxjList', params, true);
}
// 获取人员统计列表
export async function ryxjList(params) {
    return post(erpserver+'/taskrpt/ryxjList', params, true);
}

